import I18n from 'I18n';
import { useState } from 'react';
import UIFlex from 'UIComponents/layout/UIFlex';
import UISideNavItem from 'UIComponents/nav/UISideNavItem';
import { AddItemToPlaylistButton, MyPlaylistsSearch, RemoveItemFromPlaylistButton } from '..';
import { LikeLink } from '../../../components/AcademyLinks';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'academy-common-lib/utils/Styling';
import { CardMenuOptions } from '../../cardMenu';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UndoLink = styled(LikeLink).withConfig({
  displayName: "AddToPlaylist__UndoLink",
  componentId: "pf1379-0"
})(["flex:1;text-align:right;"]);
const AddToPlaylistList = ({
  playlists,
  itemId,
  type,
  language,
  renderList = content => /*#__PURE__*/_jsx(CardMenuOptions, {
    "aria-label": I18n.text('academyNav.heading.myPlaylists'),
    children: content
  }),
  renderRow = (content, key) => /*#__PURE__*/_jsx(UISideNavItem, {
    title: content
  }, key),
  onPlaylistClick
}) => {
  const [recentlyAdded, setRecentlyAdded] = useState([]);
  const handledAddedToPlaylist = playlistId => setRecentlyAdded(state => [...state, playlistId]);
  const handledRemovedFromPlaylist = playlistId => setRecentlyAdded(state => state.filter(id => id !== playlistId));
  return renderList(playlists && playlists.map(({
    name,
    id
  }) => {
    const showUndo = recentlyAdded.includes(id);
    const ButtonComponent = showUndo ? RemoveItemFromPlaylistButton : AddItemToPlaylistButton;
    return renderRow( /*#__PURE__*/_jsx(ButtonComponent, {
      itemId: itemId,
      itemType: type,
      language: language,
      onClick: () => {
        if (onPlaylistClick) onPlaylistClick(id);
      },
      onSuccess: () => showUndo ? handledRemovedFromPlaylist(id) : handledAddedToPlaylist(id),
      playlistId: id,
      style: {
        width: '100%'
      },
      children: /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        children: [name, /*#__PURE__*/_jsx(UndoLink, {
          style: {
            visibility: showUndo ? 'visible' : 'hidden'
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.cardMenu.undo"
          })
        })]
      })
    }), `playlist_${id}`);
  }));
};
const AddToPlaylist = ({
  trackId,
  lessonId,
  shortId,
  language,
  renderList,
  renderRow,
  loadMoreButton,
  loadMode = 'lazy-load',
  onPlaylistClick
}) => {
  const itemId = trackId || lessonId || shortId;
  const type = shortId ? 'SHORT_FORM_CONTENT' : trackId ? 'TRACK' : 'LESSON';
  return /*#__PURE__*/_jsx(MyPlaylistsSearch, {
    loadMode: loadMode,
    loadMoreButton: loadMoreButton,
    render: playlists => playlists && /*#__PURE__*/_jsx(AddToPlaylistList, {
      itemId: itemId,
      language: language,
      onPlaylistClick: onPlaylistClick,
      playlists: playlists,
      renderList: renderList,
      renderRow: renderRow,
      type: type
    })
  });
};
export default AddToPlaylist;